export function getOptionsFromEnum<T>(
  e: T
): { value: string; label: T[keyof T] }[] {
  return Object.keys(e).map(key => ({ value: key, label: e[key] }));
}
